import { Helmet } from "react-helmet";
import { Button, Img, Heading, Text, Input } from "../../components";
import Footer from "../../components/Footer";
import AboutZFlocSection from "./AboutZFlocSection";
import ProjectsSection from "./ProjectsSection";
import ServicesAndSolutionsSection from "./ServicesAndSolutionsSection";
import TechnologyExpertiseSection from "./TechnologyExpertiseSection";
import ZFLOCSection from "./ZFLOCSection";
import ContactForm from "../../modals/ContactForm";
import React, { useState, useEffect, useRef } from "react";
import Frame1618873025Page from "./Sample";
import { Menu, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion, MotionConfig } from "framer-motion";
import { TbMenu } from "react-icons/tb";

export default function ZFLOCPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDarkBg, setIsDarkBg] = useState(false);
  const [headerColor, setHeaderColor] = useState("black");
  const [iconColor, setIconColor] = useState("white");
  const [active, setActive] = useState(false);

  const DURATION = 0.25;
  const STAGGER = 0.025;

  const openModal = () => {
    setIsModalOpen(true);
    document.body.classList.add("overflow-hidden");
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.classList.remove("overflow-hidden");
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setIsDropdownOpen(false);
  };

  const dropdownRef = useRef(null);

  const toggleDropdown = (event) => {
    if (event) event.stopPropagation();
    console.log("Dropdown toggled:", !isDropdownOpen);
    setIsDropdownOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  const sectionsOrder = [
    "home",
    "about",
    "services",
    "projects",
    "testimonials",
    "expertise",
  ];

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "-50px 0px -50% 0px",
      threshold: 0.2,
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          const index = sectionsOrder.indexOf(sectionId);
          const newHeaderColor = index % 2 === 0 ? "black" : "white";
          const newIconColor = index % 2 === 0 ? "white" : "black";

          setHeaderColor(newHeaderColor);
          setIconColor(newIconColor);
        }
      });
    };

    const observer = new IntersectionObserver(
      handleIntersection,
      observerOptions
    );

    sectionsOrder.forEach((id) => {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const items = [
    {
      title: "Enterprise Software Solutions",
      image: "/images/marquee1.png",
    },
    {
      title: "DevOps and CI/CD",
      image: "/images/marquee2.png",
    },
    {
      title: "Digital Marketing",
      image: "/images/marquee1.png",
    },
    {
      title: "UX UI Design",
      image: "/images/marquee2.png",
    },
    {
      title: "Cloud Infrastructure",
      image: "/images/marquee1.png",
    },
    {
      title: "AI/ML Solutions",
      image: "/images/marquee2.png",
    },
    {
      title: "Cybersecurity",
      image: "/images/marquee1.png",
    },
    {
      title: "Blockchain",
      image: "/images/marquee2.png",
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        console.log("Clicked outside dropdown");
        setIsDropdownOpen(false);
        setActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isDropdownOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isDropdownOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const bannerHeight = document.getElementById("banner")?.offsetHeight || 0;
      if (window.scrollY > bannerHeight) {
        setShowHeader(true);
      } else {
        setShowHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const VARIANTS = {
    top: {
      open: {
        rotate: ["0deg", "0deg", "45deg"],
        top: ["35%", "50%", "50%"],
      },
      closed: {
        rotate: ["45deg", "0deg", "0deg"],
        top: ["50%", "50%", "35%"],
      },
    },
    middle: {
      open: {
        rotate: ["0deg", "0deg", "-45deg"],
      },
      closed: {
        rotate: ["-45deg", "0deg", "0deg"],
      },
    },
    bottom: {
      open: {
        rotate: ["0deg", "0deg", "45deg"],
        bottom: ["35%", "50%", "50%"],
        left: "56%",
      },
      closed: {
        rotate: ["45deg", "0deg", "0deg"],
        bottom: ["50%", "50%", "35%"],
        left: "calc(50% + 10px)",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>
          ZFLOC | Web and Mobile App Development Agency - Turn your ideas into
          reality
        </title>
        <meta
          name="description"
          content="Discover Floc's journey, mission, and vision. Specializing in UX/UI design, mobile and website development, and software solutions. Join us in shaping the future."
        />
      </Helmet>
      <div className="w-full bg-white-a700">
        <div>
          <div
            id="home"
            className="rounded-bl-[80px] rounded-br-[80px] sm:rounded-bl-[50px] sm:rounded-br-[50px] bg-black-900"
          >
            <div className="mb-[126px] flex flex-col gap-32 lg:gap-24 md:gap-24 sm:gap-16">
              <header
                className={`flex items-center justify-center bg-black-900 rounded-bl-[56px] rounded-br-[56px] shadow-xl transition-opacity duration-300 ${
                  isModalOpen ? "opacity-50" : "opacity-100"
                }`}
              >
                <div className="container-xs flex justify-between lg:justify-between xl:justify-between rounded-l-[56px] rounded-r-[56px] px-10 py-7 xl:px-[160px] lg:px-[160px]">
                  <div className="flex h-[18px] w-[36px] items-center justify-center">
                    <Img
                      src="images/nav-logo.svg"
                      alt="V1 Black Bold 1 (traced)"
                      className="my-0.5 h-[24px] w-[36px] object-contain"
                    />
                  </div>

                  <div className="relative flex items-center gap-4 md:pr-[30px] sm:pr-[30px]">
                    <div
                      className="fixed z-50 mt-[10px] sm:mt-[3px]"
                      ref={dropdownRef}
                      onClick={(event) => {
                        event.stopPropagation();
                        setActive((prev) => !prev);
                        toggleDropdown();
                      }}
                    >
                      <MotionConfig
                        transition={{
                          duration: 0.5,
                          ease: "easeInOut",
                        }}
                      >
                        <motion.button
                          initial={false}
                          animate={active ? "open" : "closed"}
                          className="relative z-10 h-14 w-14 rounded-full bg-black-900 transition-colors hover:bg-gray-900"
                        >
                          <motion.span
                            variants={VARIANTS.top}
                            className="absolute h-0.5 w-6 bg-white-a700"
                            style={{
                              y: "-50%",
                              left: "50%",
                              x: "-50%",
                              top: "35%",
                            }}
                          />
                          <motion.span
                            variants={VARIANTS.middle}
                            className="absolute h-0.5 w-6 bg-white-a700"
                            style={{
                              left: "50%",
                              x: "-50%",
                              top: "50%",
                              y: "-50%",
                            }}
                          />
                          <motion.span
                            variants={VARIANTS.bottom}
                            className="absolute h-0.5 w-3 bg-white-a700"
                            style={{
                              x: "-80%",
                              y: "50%",
                              bottom: "35%",
                              left: "50%",
                            }}
                          />
                        </motion.button>
                      </MotionConfig>
                      <AnimatePresence>
                        {isDropdownOpen && (
                          <motion.div
                            initial={{ opacity: 0, y: -50 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -50 }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                            className="fixed top-0 left-0 w-full h-full bg-white-a700 backdrop-blur-lg flex flex-col justify-center items-center"
                          >
                            <img
                              src="images/dash-logo.svg"
                              alt="Logo"
                              className="absolute top-10 left-16 h-8 w-auto cursor-pointer"
                              onClick={(event) => {
                                event.stopPropagation();
                                setIsDropdownOpen(false);
                                setActive(false);
                                scrollToSection("home");
                              }}
                            />
                            {/* <motion.div
                                className="absolute inset-0 flex items-center justify-center"
                                initial={{ opacity: 0 }}
                                animate={{
                                  opacity: 1,
                                  rotateX: [0, 360],
                                  rotateY: [0, 360],
                                  rotateZ: [0, 360],
                                  scale: [1, 1.2, 1],
                                }}
                                transition={{
                                  duration: 6,
                                  ease: "linear",
                                  repeat: Infinity,
                                }}
                              >
                                <div
                                  className="w-[90vw] h-[90vh] max-w-4xl max-h-[600px] border-2 border-black-900 rounded-full pointer-events-none"
                                  style={{ perspective: "1000px" }}
                                />
                              </motion.div> */}
                            <div className="2xl:ml-[500px] xl:ml-[500px] lg:ml-[500px] space-y-6 text-center font-semibold">
                              {[
                                { title: "home", section: "home" },
                                { title: "about", section: "about" },
                                { title: "services", section: "services" },
                                { title: "projects", section: "projects" },
                                { title: "testimonials", section: "testimonials" },
                                { title: "contact", section: null },
                              ].map(({ title, section }, index) => (
                                <motion.button
                                  key={index}
                                  initial="initial"
                                  whileHover="hovered"
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    console.log(
                                      "Dropdown option clicked:",
                                      title
                                    );
                                    setIsDropdownOpen(false);
                                    setActive(false);
                                    if (section) {
                                      scrollToSection(section);
                                    } else {
                                      openModal();
                                    }
                                  }}
                                  className="relative block overflow-hidden text-7xl font-druk sm:text-4xl md:text-6xl lg:text-7xl cursor-pointer"
                                  style={{ lineHeight: 0.75 }}
                                >
                                  <div>
                                    {title.split("").map((l, i) => (
                                      <motion.span
                                        variants={{
                                          initial: { y: 0 },
                                          hovered: { y: "-100%" },
                                        }}
                                        transition={{
                                          duration: DURATION,
                                          ease: "easeInOut",
                                          delay: STAGGER * i,
                                        }}
                                        className="inline-block"
                                        key={i}
                                      >
                                        {l}
                                      </motion.span>
                                    ))}
                                  </div>
                                  <div className="absolute inset-0">
                                    {title.split("").map((l, i) => (
                                      <motion.span
                                        variants={{
                                          initial: { y: "100%" },
                                          hovered: { y: 0 },
                                        }}
                                        transition={{
                                          duration: DURATION,
                                          ease: "easeInOut",
                                          delay: STAGGER * i,
                                        }}
                                        className="inline-block"
                                        key={i}
                                      >
                                        {l}
                                      </motion.span>
                                    ))}
                                  </div>
                                </motion.button>
                              ))}
                            </div>
                            <motion.div
                              className="absolute left-16 bottom-20 text-lg text-black-900 font-medium md:hidden sm:hidden"
                              initial={{ opacity: 0, x: -50 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{
                                duration: 0.5,
                                ease: "easeOut",
                                delay: 0.3,
                              }}
                            >
                              <Heading
                                as="p"
                                className="text-purple-400 text-lg leading-10 tracking-[4px] uppercase"
                              >
                                Get in Touch
                              </Heading>
                              <Link to="mailto:info@zfloc.com">
                                <p className="text-5xl font-normal pt-5">
                                  info@zfloc.com
                                </p>
                              </Link>
                              <Link to="tel:8848882621">
                                <p className="text-4xl font-normal pt-1">
                                  +91 8848882621
                                </p>
                              </Link>
                              <p className="text-2xl font-light py-5">
                                Kochi, Kerala
                              </p>
                            </motion.div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>
                </div>
              </header>
              <div className="flex flex-col gap-[158px] lg:gap-[118px] md:gap-[118px] sm:gap-[59px]">
                <div className="container-xs flex flex-col items-center px-14 lg:px-5 md:px-5 sm:px-2">
                  <div className="flex w-[94%] flex-col items-center gap-20 xl:w-full xl:gap-20 lg:w-full lg:gap-20 md:w-full md:gap-[60px] sm:gap-[1px]">
                    <Img
                      src="images/banner-3.svg"
                      alt="Feature Image"
                      className="h-[240px] w-full lg:w-[80%] xl:w-[80%] lg:h-auto xl:h-auto md:h-auto"
                    />
                    <Heading
                      size="text5xl"
                      as="p"
                      className="text-center text-[48px] font-spacegrotesk font-light uppercase leading-[61px] sm:leading-[30px] text-white-a700 lg:text-[40px] md:text-[30px] sm:text-[20px]"
                    >
                      <>
                        Transform Your Dream <br />
                        into reality
                      </>
                    </Heading>
                  </div>
                </div>
                <div className="w-full overflow-hidden bg-black py-1">
                  <div className="relative flex whitespace-nowrap gap-5 pb-[100px]">
                    {/* First Set of Data */}
                    <div className="flex items-center animate-marquee">
                      {items.concat(items).map((item, index) => (
                        <div
                          key={index}
                          className="slider-item inline-flex items-center justify-center px-16 py-5 sm:py-2 md:py-3 rounded-full border border-white text-white-a700 uppercase mx-5 overflow-hidden"
                        >
                          <img
                            src={item.image}
                            alt={item.title}
                            className="h-full w-full mr-3 object-contain"
                          />
                          <span className="text-[32px] sm:text-[20px] md:text-[26px] font-light text-center leading-none whitespace-nowrap">
                            {item.title}
                          </span>
                        </div>
                      ))}
                    </div>

                    {/* Duplicate Set of Data */}
                    {/* <div className="flex items-center animate-marquee">
                        {items.map((item, index) => (
                          <div
                            key={`duplicate-${index}`}
                            className="slider-item inline-flex items-center justify-center px-16 py-5 sm:py-2 md:py-3 rounded-full border border-white text-white-a700 uppercase mx-5 overflow-hidden"
                          >
                            <img
                              src={item.image}
                              alt={item.title}
                              className="h-full w-full mr-3 object-contain"
                            />
                            <span className="text-[32px] sm:text-[20px] md:text-[26px] font-light text-center leading-none whitespace-nowrap">
                              {item.title}
                            </span>
                          </div>
                        ))}
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="about">
            <div className="flex flex-col items-end">
              <Img
                src="images/bg-1.png"
                alt="Vector Image"
                className="mr-3 h-[676px] w-[36%] object-contain md:mr-0"
              />
              {/* about z floc section */}
              <AboutZFlocSection />
            </div>
          </div>
          {/* services and solutions section */}
          <div id="services">
            <ServicesAndSolutionsSection />
          </div>
          {/* projects section */}
          <div id="projects">
            <ProjectsSection />
          </div>
          {/*zfloc section */}
          <div id="testimonials">
            <Frame1618873025Page />
          </div>
          {/* technology expertise section */}
          <div id="expertise">
            <TechnologyExpertiseSection />
          </div>
          <div
            id="footer"
            className="relative mt-[100px] xl:mt-[100px] lg:mt-[100px] md:mt-[20px] sm:mt-[20px] h-[664px] content-center xl:h-auto lg:h-auto md:h-auto sm:h-auto"
          >
            <div className="flex-1">
              <div className="relative h-[336px] rounded-tl-[80px] rounded-tr-[80px] bg-black-900" />
              {/* <Footer /> */}
              <footer
                className={` flex justify-center items-start h-[664px] xl:h-auto lg:h-auto md:h-auto sm:h-auto left-0 bottom-0 right-0 top-0 py-[92px] sm:py-4 m-auto lg:py-8 md:py-10 absolute bg-[url(/public/images/bg-4.svg)] bg-cover bg-no-repeat flex-1 z-0`}
              >
                <div className="container-xs mb-[340px] flex justify-center xl:px-[100px] lg:px-[100px] md:px-5 sm:px-3">
                  <div className="flex w-full items-start justify-between gap-5 md:flex-col sm:flex-col">
                    <div className="flex w-[44%] items-start justify-center gap-[30px] self-center md:w-full md:flex-col sm:flex-col">
                      <Img
                        src="images/👋.png"
                        alt="Close Image"
                        className="h-[88px] w-[8%] sm:h-[62px] sm:w-full object-contain md:w-full md:h-[63px]"
                      />
                      <Heading
                        as="p"
                        className="mt-3 sm:mt-1 w-[92%] self-end text-[52px] font-medium leading-[62px] tracking-[-2.00px] xl:leading-[62px] xl:tracking-[-2.00px] lg:leading-[62px] lg:tracking-[-2.00px] sm:leading-[30px] sm:tracking-[-1.00px] text-white-a700 xl:w-[92%] xl:text-[38px] lg:w-[92%] lg:text-[36px] md:w-full md:text-[29px] md:text-center sm:text-center sm:w-[100%] sm:text-[21px]"
                      >
                        Big solutions start with simple conversations.
                      </Heading>
                    </div>
                    <Button
                      color="black_900"
                      className="text-[32px] sm:text-[20px] md:text-[22px] font-light sm:mt-1 md:mt-1 min-w-[160px] sm:min-w-[150px] md:min-w-[150px] rounded-[100px] self-center border border-solid border-white-a700 py-[18px] px-[24px] sm:p-[14px] md:p-[14px] uppercase sm:px-4"
                      onClick={openModal}
                    >
                      LET'S TALK
                    </Button>
                  </div>
                </div>

                {/* Contact Form Modal */}
                {/* <ContactForm isOpen={isModalOpen} onRequestClose={closeModal} /> */}
              </footer>
              <div className="relative mt-[-40px] xl:mt-[-80px] lg:mt-[-120px] flex justify-center bg-black-900 py-20 xl:py-8 lg:py-8 md:py-5 sm:py-4 px-[100px] sm:px-[40px]">
                <div className="container-xs flex justify-center xl:px-10 lg:px-5 md:px-5">
                  <div className="flex w-full rounded-[32px] border-2 border-solid border-gray-900_02 md:flex-col sm:flex-col">
                    <div className="flex w-[20%] justify-center md:border-r-0 sm:border-r-0 border-r-2 border-solid border-gray-900_02 md:border-b-2 md:border-solid md:border-gray-900_02 sm:border-b-2 sm:border-solid sm:border-gray-900_02 px-14 py-[94px] lg:py-[88px] md:w-full sm:w-full md:p-5 sm:p-4">
                      <Img
                        src="images/footerLogo.svg"
                        alt="Logo Image"
                        className="h-[20px] w-[105px] object-contain"
                      />
                    </div>
                    <div className="flex-1 md:self-stretch">
                      <div className="flex items-center justify-between gap-5 border-b-2 border-solid border-gray-900_02 flex-row md:flex-col sm:flex-col md:items-center">
                        <div className="flex w-[64%] justify-center border-r-2 border-solid border-gray-900_02 md:border-b-2 md:border-solid md:border-gray-900_02 sm:border-b-2 sm:border-solid sm:border-gray-900_02 p-10 md:w-full sm:w-full sm:p-4 md:border-r-0 sm:border-r-0">
                          <div className="flex w-[88%] flex-wrap justify-between gap-5 lg:w-full md:w-full">
                            <a>
                              <Heading
                                as="h2"
                                className="text-[14px] font-medium text-gray-400_01 cursor-pointer"
                                onClick={() => scrollToSection("home")}
                              >
                                Home
                              </Heading>
                            </a>
                            <a>
                              <Heading
                                as="h3"
                                className="text-[14px] font-medium text-gray-400_01 cursor-pointer"
                                onClick={() => scrollToSection("about")}
                              >
                                About Us
                              </Heading>
                            </a>
                            <a>
                              <Heading
                                as="h4"
                                className="text-[14px] font-medium text-gray-400_01 cursor-pointer"
                                onClick={() => scrollToSection("services")}
                              >
                                Services
                              </Heading>
                            </a>
                            <a>
                              <Heading
                                as="h5"
                                className="text-[14px] font-medium text-gray-400_01 cursor-pointer"
                                onClick={() => scrollToSection("projects")}
                              >
                                Projects
                              </Heading>
                            </a>
                            <a>
                              <Heading
                                as="h6"
                                className="text-[14px] font-medium text-gray-400_01 cursor-pointer"
                                onClick={() => scrollToSection("expertise")}
                              >
                                Expertise
                              </Heading>
                            </a>
                            <a>
                              <Heading
                                as="p"
                                className="text-[14px] font-medium text-gray-400_01 cursor-pointer"
                                onClick={openModal}
                              >
                                Contact
                              </Heading>
                            </a>
                          </div>
                        </div>
                        <Link to="mailto:info@zfloc.com">
                          <Heading
                            as="p"
                            className="mr-[140px] font-inter text-[28px] font-medium tracking-[-0.60px] text-gray-400_01 lg:text-[23px] md:mr-0 md:text-[22px] md:pb-3 sm:mr-0 sm:text-[22px] sm:pb-3"
                          >
                            info@zfloc.com
                          </Heading>
                        </Link>
                      </div>
                      <div className="flex md:flex-col sm:flex-col">
                        <div className="md:border-b-2 md:border-solid md:border-gray-900_02 sm:border-b-2 sm:border-solid sm:border-gray-900_02">
                          <Link to="tel:8848882621">
                            <Button
                              size="3xl"
                              variant="outline"
                              shape="square"
                              leftIcon={
                                <Img
                                  src="images/phone.svg"
                                  alt="Frame"
                                  className="h-[18px] w-[18px] object-contain"
                                />
                              }
                              className="w-full text-gray-400_01 gap-1 !border-r-2 border-solid border-gray-900_02 px-[33px] font-inter font-normal sm:px-4 md:!border-r-0 md:py-4"
                            >
                              +91 8848882621
                            </Button>
                          </Link>
                        </div>
                        <div className="flex w-1\2 justify-center gap-2 sm:gap-0 border-r-2 border-solid border-gray-900_02 md:border-b-2 md:border-solid md:border-gray-900_02 sm:border-b-2 sm:border-solid sm:border-gray-900_02 p-[34px] sm:p-4 md:!border-r-0 md:py-4">
                          <Link to="https://x.com/ZflocTech" target="_blank">
                            <Button
                              size="xs"
                              shape="circle"
                              className="w-[106px] lg:w-[60px] sm:w-[50px] rounded-[18px] px-2"
                            >
                              <Img src="images/twitter.svg" />
                            </Button>
                          </Link>
                          <Link
                            to="https://www.instagram.com/zfloc_technologies?igsh=MWxiZzMyYmF6bHAzNw=="
                            target="_blank"
                          >
                            <Button
                              size="xs"
                              shape="circle"
                              className="w-[106px] lg:w-[60px] sm:w-[50px] rounded-[18px] px-2"
                            >
                              <Img src="images/insta.svg" />
                            </Button>
                          </Link>
                          <Link
                            to="https://www.facebook.com/profile.php?id=100089340318234"
                            target="_blank"
                          >
                            <Button
                              size="xs"
                              shape="circle"
                              className="w-[106px] lg:w-[60px] sm:w-[50px] rounded-[18px] px-2"
                            >
                              <Img src="images/facebook.svg" />
                            </Button>
                          </Link>
                          <Link
                            to="https://www.linkedin.com/company/zfloc-technologies/?viewAsMember=true"
                            target="_blank"
                          >
                            <Button
                              size="xs"
                              shape="circle"
                              className="w-[106px] lg:w-[60px] sm:w-[50px] rounded-[18px] px-2"
                            >
                              <Img src="images/linkedIn.svg" />
                            </Button>
                          </Link>
                        </div>
                        <Button
                          size="3xl"
                          variant="outline"
                          shape="square"
                          className="w-full text-gray-400_01 !border-r-0 border-solid border-gray-900_02 px-[33px] font-inter sm:px-1 md:py-4"
                        >
                          © 2025 Zfloc Technologies Pvt Ltd.
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ContactForm
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          className="z-50"
        />
      </div>
    </>
  );
}
